import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "13",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m7.621.358 6.285 11.11a.695.695 0 0 1-.625 1.03H.711a.694.694 0 0 1-.625-1.03L6.371.358a.725.725 0 0 1 1.25 0Zm-.625.925-5.78 10.215h11.56L6.996 1.283Zm-.368 9.147a.93.93 0 0 0 .368.068.943.943 0 0 0 .685-.275.939.939 0 0 0 0-1.35.965.965 0 0 0-.685-.27.945.945 0 0 0-.68 1.62c.089.09.195.16.312.207Zm-.362-6.932.1 4.355h1.28l.12-4.355h-1.5Z",
  fill: "#5A5A5A"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };